import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import Swal from 'sweetalert2';
import { get_token } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.fetchSections();
    },
    data() {
        return ({
            sections: [],
            selectedSections: [],
            form_id: this.$route.params.form_id,
            section_name: '',
            is_locked: false,
            edit_is_locked: false,
            errors: {
                section_name: '',
            },
            edit_section: '',
            edit_section_id: '',
            isLoading: false,
        });
    },

    methods: {
        getToken() {
            return get_token();
        },
        fetchSections() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;

                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_sections/`,
                    method: "POST",
                    headers: {
                        "Authorization": `Token ${this.getToken()}`,
                        "Content-Type": "application/json"
                    },
                    success: (response) => {
                        this.sections = response.data.sections;
                        resolve();
                    },
                    error: (error) => {
                        Swal.fire({
                            icon: "error",
                            title: "Failed to load sections",
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                        reject(error);
                    },
                    complete: () => {
                        this.isLoading = false;
                    }
                });
            });
        },
        createSection() {
            if (!this.section_name) {
                Swal.fire({
                    icon: 'error',
                    title: 'Section name is required',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            const formData = new FormData();
            formData.append('section_name', this.section_name);
            formData.append('is_locked', this.is_locked);

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_section/`,
                method: "POST",
                headers: { Authorization: `Token ${this.getToken()}` },
                data: formData,
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Section created",
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.sections.unshift(response.data);
                            this.resetForm();
                            $('#create_section').modal('hide');
                        });
                    }
                },
                error: (response) => {
                    this.errors.section_name = response.responseJSON.message || {};
                }
            });
        },
        deleteSection(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "This will permanently delete the section.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_section/`,
                        method: "DELETE",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        data: { section_id: id },
                        success: () => {
                            this.sections = this.sections.filter(section => section.id !== id);
                            Swal.fire({
                                icon: "success",
                                title: "Deleted!",
                                text: "The section has been deleted.",
                                showConfirmButton: false,
                                timer: 1000,
                                position: 'bottom-end',
                                toast: true
                            });
                        },
                        error: () => {
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "Failed to delete the section.",
                                position: 'bottom-end',
                                showConfirmButton: false,
                                timer: 3000,
                                toast: true
                            });
                        }
                    });
                }
            });
        },
        resetForm() {
            this.section_name = '';
            this.errors = {};
        },
        editSectionName(section) {
            if (section) {
                this.edit_is_locked = section.is_locked;
                this.edit_section = section.name;
                this.edit_section_id = section.id;
            }
        },
        assignToForm() {
            if (this.selectedSections.length === 0) {
                Swal.fire({
                    icon: "info",
                    title: "Select at least one section to assign",
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }
            const payload = {
                form_id: this.form_id,
                section_ids: this.selectedSections
            };
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/assign_form_sections/`,
                method: "POST",
                headers: { Authorization: `Token ${this.getToken()}` },
                contentType: "application/json",
                data: JSON.stringify(payload),
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Sections assigned",
                            showConfirmButton: false,
                            timer: 1500,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.selectedSections = [];
                            window.history.back();
                        });
                    }
                }
            });
        },
        editSection(section) {
            const payload = {
                section_id: section.id,
                update_values: {
                    name: this.edit_section,
                    is_locked: this.edit_is_locked
                },
            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_section/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        const updatedSection = this.sections.find(s => s.id === section.id);
                        if (updatedSection) {
                            updatedSection.name = this.edit_section;
                        }

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated',
                            text: 'Section has been updated.',
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        });
                        $(`#edit_section_${section.id}`).modal('hide');
                    }
                },
                error: () => {
                    Swal.fire({
                      title: "Error",
                      text: "Failed to update section.",
                      icon: "error",
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                }
            });
        }
    }
};